export default __webpack_public_path__ + "static/media/Info_En_Ciudad_Destino.d6a97e01.png";